import axios from "axios";
const { BACKEND_URL, BACKEND_PENYEDIA, API_NO_REG } = window.ENV;

export function getSerialNumber(
  page = 1,
  size = 10,
  kode = "",
  npwp = "",
  tahun = "",
  bulan = ""
) {
  if (npwp) {
    return axios.get(
      `${BACKEND_URL}/api/mtd/monitoring/serial-number?page=${page}&size=${size}&npwpPengguna=${npwp}&tahun=${tahun}&bulan=${bulan}`
    );
  } else {
    return axios.get(
      `${BACKEND_URL}/api/mtd/monitoring/serial-number?page=${page}&size=${size}&kodeDistributor=${kode}&tahun=${tahun}&bulan=${bulan}`
    );
  }
}

export function getPembubuhan(
  page = 1,
  size = 10,
  kode = "",
  npwp = "",
  tahun = "",
  bulan = ""
) {
  if (npwp) {
    return axios.get(
      `${BACKEND_URL}/api/mtd/monitoring/pembubuhan?page=${page}&size=${size}&npwpPengguna=${npwp}&tahun=${tahun}&bulan=${bulan}`
    );
  } else {
    return axios.get(
      `${BACKEND_URL}/api/mtd/monitoring/pembubuhan?page=${page}&size=${size}&kodeDistributor=${kode}&tahun=${tahun}&bulan=${bulan}`
    );
  }
}


export function getPenyedia(
  page = 1,
  size = 10,
  kode = "",
  nama = "",
  npwp = "",
  status = "",
) {
  if (npwp) {
    if(nama){
      return axios.get(
        `${BACKEND_URL}/api/mtd/monitoring/distributor?page=${page}&size=${size}&namaDistributor=${nama}&npwpDistributor=${npwp}&status=${status}`
      );
    }else {
    return axios.get(
      `${BACKEND_URL}/api/mtd/monitoring/distributor?page=${page}&size=${size}&npwpDistributor=${npwp}&status=${status}`
    );
  }
  } else {
    if(nama){
      return axios.get(
        `${BACKEND_URL}/api/mtd/monitoring/distributor?page=${page}&size=${size}&kodeDistributor=${kode}&namaDistributor=${nama}&status=${status}`
      );
    } else {
      return axios.get(
        `${BACKEND_URL}/api/mtd/monitoring/distributor?page=${page}&size=${size}&kodeDistributor=${kode}&status=${status}`
      );
    }
  }
}

export function getPenyediaById(id){
  return axios.get(`${BACKEND_URL}/api/mtd/monitoring/distributor/id?id=${id}`)
}

export function getPemungutById(id){
  return axios.get(`${BACKEND_URL}/api/mtd/monitoring/pengguna/id?id=${id}`)
}


export function getPemungutByKodeDistributor(kode, page = 1, size = 10, npwp = "", nama = "", status = ""){
  return axios.get(`${BACKEND_URL}/api/mtd/monitoring/pengguna/${kode}?page=${page}&size=${size}&namaPengguna=${nama}&npwpPengguna=${npwp}&status=${status}`)
}

export function getSerialNumberByNpwpPemungut(npwp, page = 1, size = 10, bulan = "", tahun = ""){
  return axios.get(`${BACKEND_URL}/api/mtd/monitoring/serial-number/${npwp}?page=${page}&size=${size}&tahun=${tahun}&bulan=${bulan}`)
}

export function getPembubuhanByNpwpPemungut(
  npwp = "",
  page = 1,
  size = 10,
  bulan = "",
  tahun = ""
) {
    return axios.get(
      `${BACKEND_URL}/api/mtd/monitoring/pembubuhan?page=${page}&size=${size}&npwpPengguna=${npwp}&tahun=${tahun}&bulan=${bulan}`
    );
}

export function getSerialNumberByNpwpPemungutDashboard(
  page = 1,
  size = 10,
  npwp = "",
  bulan = "",
  tahun = ""
) {
    return axios.get(
      `${BACKEND_URL}/api/mtd/monitoring/serial-number?page=${page}&size=${size}&npwpPengguna=${npwp}&tahun=${tahun}&bulan=${bulan}`
    );
}


        /* Begin Penyedia */
        export function getListDistributor(values){
          return axios.post(`${BACKEND_PENYEDIA}/distributor/list`,values)
        }

        export function savePenyedia(jsonData, formData){
          const config = {
            headers: {
              "Content-type": "multipart/form-data",
            },
          };
          return axios.post(`${BACKEND_PENYEDIA}/distributor/add?${jsonData}`, formData, config)
          // return axios.post(`${BACKEND_PENYEDIA}/distributor/add?jsondata=${jsonData}`, formData, config)
        }

        export function getPdf(idDistributor){
          return axios.get(`${BACKEND_PENYEDIA}/pdf/download/${idDistributor}`)
        }

        export function getListPrinter(values){
          return axios.post(`${BACKEND_PENYEDIA}/printercertified/list`,values)
        }

        export function savePrinter(npwpDistributor, brand, type){
          return axios.post(`${BACKEND_PENYEDIA}/printercertified/add`,{
            npwpDistributor,
            brand,
            type
          })
        }
        /* End of Penyedia */




        export function getProfilWp(npwp){
          return axios.get(`${BACKEND_URL}/api/soa/${npwp}`)
        }

        export function getDataDashboardByNpwp(npwp, page=1, size=30){
          return axios.get(`${BACKEND_URL}/api/dashboard-referensi/getlistdatareferensi?npwpPemohon=${npwp}&page=${page}&size=${size}`)
        }
        export function getDataDashboardByNpwpWithStatus(npwp,status, page=1, size=30){
          return axios.get(`${BACKEND_URL}/api/dashboard-referensi/getlistdatareferensiwithfgproses?npwpPemohon=${npwp}&status=${status}&page=${page}&size=${size}`)
        }

        export function getRefNamaFasilitas(){
          return axios.get(`${BACKEND_URL}/api/ref-pengaturan/get-active-nama-ref`)
        }

        export function saveKontraktorUtama(idSurat, formData){
          const config = {
            headers: {
              "Content-type": "multipart/form-data",
            },
          };
          return axios.post(`${BACKEND_URL}/api/ku-phln/?idJenisSurat=${idSurat}`,formData, config)
        }

        export function getProyekByNpwp(npwp){
          return axios.get(`${BACKEND_URL}/api/ku-phln/getproyekbynpwp?npwp=${npwp}`)
        }

        export function getDetailBps(npwp, bps){
          return axios.get(`${BACKEND_URL}/api/ku-phln/getbynpwpbps?npwp=${npwp}&bps=${bps}`)
        }

        export function getDetailBpsBkp(npwp, bps){
          return axios.get(`${BACKEND_URL}/api/bkpjkp-phln/getbynpwpbps?npwp=${npwp}&bps=${bps}`)
        }

        export function getKontraktorById(id){
          return axios.get(`${BACKEND_URL}/api/ku-phln/${id}`)
        }

        export function saveBkpjkp(formData){
          const config = {
            headers: {
              "Content-type": "multipart/form-data",
            },
          };
          return axios.post(`${BACKEND_URL}/api/bkpjkp-phln/`,formData, config)
        }

        export function ssoCheckCode(code){
          return axios.get(`${BACKEND_URL}/auth/cek?code=${code}`)
        }

        export function ssoCheckToken(token){
          return axios.get(`${BACKEND_URL}/auth/cek-token?token=${token}`)
        }

        export function cetakKu(idProyek){
          return axios.get(`${BACKEND_URL}/api/ku-phln/cetakSuket?idProyek=${idProyek}`)
        }

        export function cetakBkpJkp(id){
          return axios.get(`${BACKEND_URL}/api/bkpjkp-phln/cetak?idBkpjkp=${id}`)
        }

        export function getJenisTransaksi(){
          return axios.get(`${BACKEND_URL}/api/ref-jenistrx/get-active-nama-ref`)
        }

        export function cetakBps(npwp, noBps){
          return axios.get(`${BACKEND_URL}/api/dashboard-referensi/cetakBps?noBps=${noBps}&npwpPemohon=${npwp}`)
        }

        export function checkNpwpIp(npwp){
          return axios.get(`${BACKEND_URL}/api/dashboard-referensi/checkNpwp?npwp15=${npwp}`)
        }

        export function checkNoReg(noReg){
          return axios.get(`${API_NO_REG}${noReg}`)
        }